import { useMatches, useParams } from 'react-router-dom';

type ProjectParams = {
    id?: string;
    methodology?: string;
    orderId?: string;
    orderChangeId?: string;
    versionId?: string;
};

export function useProjectParams(): ProjectParams {
    const params = useParams<ProjectParams>();
    const matches = useMatches();

    const methodologyFromHandle = [...matches]
        .reverse()
        .find((m) => (m.handle as { methodology?: string } | undefined)?.methodology)?.handle as
        | { methodology?: string }
        | undefined;

    return {
        ...params,
        methodology: params.methodology ?? methodologyFromHandle?.methodology,
    };
}
